import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _Object$fromEntries from "@babel/runtime-corejs3/core-js-stable/object/from-entries";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _Object$entries from "@babel/runtime-corejs3/core-js-stable/object/entries";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _endsWithInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/ends-with";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CheckBoxField, InputField, SelectField } from '@unite-us/ui';
import { LocationAddressField, useLocationAddressFields } from '@unite-us/client-utils';
import InfoPopover from '@unite-us/client-utils/dist/InfoPopover';
import { AddressRemoveButton } from './components';
import { PRIMARY_ADDRESS_TOOLTIP } from './constants';
import './AddressField.scss';
import { isRequired } from '../../../../utils/validations';
import { Field, useForm, useField } from 'react-final-form';
import { useFeatureFlag } from '../../../../../hooks/useFeatureFlag';
import { getAdapter } from '../../../../../config/api';
export function AddressField(props) {
  var _context2;
  var addressTypes = props.addressTypes,
    field = props.field,
    fieldName = props.fieldName,
    google = props.google,
    id = props.id,
    index = props.index,
    inline = props.inline,
    inputStyle = props.inputStyle,
    isValidAddress = props.isValidAddress,
    label = props.label,
    labelStyle = props.labelStyle,
    multi = props.multi,
    remove = props.remove,
    setFormErrors = props.setFormErrors;
  var formValidator = {
    isRequiredValidator: function isRequiredValidator(values) {
      var isReq = isRequired(values);
      if (isReq !== null) {
        setFormErrors(isReq);
        return isReq;
      }
      return '';
    }
  };
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showRemove = _useState2[0],
    setShowRemove = _useState2[1];
  var form = useForm();
  var useFieldPrefixed = function useFieldPrefixed(name, config) {
    var _context;
    return useField(_concatInstanceProperty(_context = "".concat(fieldName, ".")).call(_context, name), config);
  };
  // eslint-disable-next-line react-hooks/rules-of-hooks
  var addressFields = useLocationAddressFields(useFieldPrefixed, _defineProperty({}, "".concat(fieldName, ".city"), formValidator.isRequiredValidator));
  var cityTouched = addressFields.city.meta.touched;
  var hookedAddressFields = _Object$fromEntries(_mapInstanceProperty(_context2 = _Object$entries(addressFields)).call(_context2, function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      name = _ref2[0],
      field = _ref2[1];
    return [name, _objectSpread(_objectSpread({}, field), {}, {
      input: _objectSpread(_objectSpread({}, field.input), {}, {
        onChange: function onChange(event) {
          var _props$clearValidatio;
          field.input.onChange(event);
          (_props$clearValidatio = props.clearValidation) === null || _props$clearValidatio === void 0 || _props$clearValidatio.call(props);
        }
      })
    })];
  }));
  var onPrimaryChanged = function onPrimaryChanged(params) {
    var _context3;
    var phones = _filterInstanceProperty(_context3 = form.getRegisteredFields()).call(_context3, function (rf) {
      return _endsWithInstanceProperty(rf).call(rf, "is_primary");
    });
    phones.forEach(function (p) {
      if (!_includesInstanceProperty(p).call(p, params.input.name)) form.change(p, false);
    });
  };
  var toggleRemove = function toggleRemove() {
    setShowRemove(!showRemove);
  };
  var confirmRemove = function confirmRemove() {
    toggleRemove();
    props.remove();
  };
  var groupLabelClass = function groupLabelClass() {
    return classNames('group-label', {
      hidden: label === undefined,
      inline: inline
    });
  };
  var style = {
    label: labelStyle,
    input: inputStyle
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "address-field"
  }, /*#__PURE__*/React.createElement("div", {
    className: "address-field__title row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xs-12"
  }, /*#__PURE__*/React.createElement("strong", {
    className: groupLabelClass(),
    style: labelStyle
  }, label))), isValidAddress === false && /*#__PURE__*/React.createElement("div", {
    className: "col-xs-9 address-field__error",
    tabIndex: "0"
  }, isValidAddress === false && /*#__PURE__*/React.createElement("p", null, "*Invalid Address. Please make sure you enter a valid address.")), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xs-12 col-sm-6"
  }, /*#__PURE__*/React.createElement(Field, {
    name: "".concat(fieldName, ".address_type"),
    validate: formValidator.isRequiredValidator
  }, function (params) {
    return /*#__PURE__*/React.createElement(SelectField, _extends({
      autoFocus: true,
      searchEnabled: false,
      className: "address-field-type",
      id: "".concat(id, "-type"),
      inline: inline,
      label: "Address Type",
      labelKey: "display_name",
      options: addressTypes,
      placeholder: "Select type",
      style: style,
      required: true,
      valueKey: "value"
    }, params));
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-xs-12 col-sm-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center h-full mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-1 gap-2"
  }, /*#__PURE__*/React.createElement(Field, {
    name: "".concat(fieldName, ".is_primary"),
    type: "checkbox"
  }, function (params) {
    return /*#__PURE__*/React.createElement(CheckBoxField, _extends({
      className: "w-auto check-box-field",
      id: "".concat(fieldName, ".is_primary"),
      label: "Primary",
      onChange: function onChange() {
        return onPrimaryChanged(params);
      }
    }, params, {
      showHint: false,
      showError: false
    }));
  }), /*#__PURE__*/React.createElement(InfoPopover, {
    id: "info-popover-".concat(index),
    className: "is_primary-info-icon",
    placement: "bottom-start"
  }, /*#__PURE__*/React.createElement("div", {
    className: "is_primary-info-icon__popover-content"
  }, PRIMARY_ADDRESS_TOOLTIP))), /*#__PURE__*/React.createElement("div", {
    className: "mb-4"
  }, /*#__PURE__*/React.createElement(AddressRemoveButton, {
    confirmRemove: confirmRemove,
    displayText: 'Delete Address',
    field: field,
    iconSize: 18,
    multi: multi,
    remove: remove,
    showRemove: showRemove,
    toggleRemove: toggleRemove,
    trashColor: "#4571BA"
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xs-12"
  }, /*#__PURE__*/React.createElement(LocationAddressField, _extends({
    id: "".concat(id, "-address-typeahead"),
    label: "Address",
    fieldNamePath: null,
    required: true,
    initialTouched: cityTouched,
    google: google,
    coreApiClientBase: getAdapter('coreApiClientBase')
  }, hookedAddressFields)), /*#__PURE__*/React.createElement(Field, {
    name: "".concat(fieldName, ".line_2")
  }, function (params) {
    return /*#__PURE__*/React.createElement(InputField, _extends({
      autoComplete: "no",
      id: "".concat(id, "-line2"),
      inline: inline,
      label: "Address Line 2",
      style: style
    }, params));
  }))));
}

// TODO: Fix these prop type warnings. Too scared to fix now. -BD

AddressField.propTypes = {
  addressPath: PropTypes.string,
  addressTypes: PropTypes.array.isRequired,
  // eslint-disable-next-line react/require-default-props
  id: PropTypes.string,
  index: PropTypes.number.isRequired,
  // eslint-disable-next-line react/require-default-props
  inline: PropTypes.bool.isRequired,
  // eslint-disable-next-line react/require-default-props
  inputStyle: PropTypes.object.isRequired,
  google: PropTypes.object.isRequired,
  // eslint-disable-next-line react/require-default-props
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  // eslint-disable-next-line react/require-default-props
  labelStyle: PropTypes.object.isRequired,
  // eslint-disable-next-line react/require-default-props
  multi: PropTypes.bool.isRequired,
  requireAddressLine1: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props
  remove: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  clearValidation: PropTypes.func
};
AddressField.defaultProps = {
  addressPath: 'addresses',
  // eslint-disable-next-line react/default-props-match-prop-types
  inline: true,
  // eslint-disable-next-line react/default-props-match-prop-types
  inputStyle: {},
  // eslint-disable-next-line react/default-props-match-prop-types
  labelStyle: {},
  // eslint-disable-next-line react/default-props-match-prop-types
  multi: true,
  requireAddressLine1: false
};
export default AddressField;
//# sourceMappingURL=AddressField.js.map